import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kit na nebu",
  "description": "",
  "published": "2007-03-25T00:00:00.000Z",
  "redirect_from": ["/blog/kit-na-nebu/swizec/254"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi je `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Airbus_A380"
      }}>{`novi kit neba`}</a>{` dozivel testno voznjo na katero ga je pospreila kopica novinarjev in poslovnih ljudi. Novinarji so potem ustvarili`}<a parentName="p" {...{
        "href": "http://www.popularmechanics.com/blogs/science_news/4213543.html"
      }}>{` zanimivo zgodbico`}</a>{`, ki jo pospremlja impresiven video dogajanja.`}</p>
    <p>{`Najvecje skrbi okoli novega Airbusa A380 se trenutno menda vrtijo okoli njegove velikosti in teze, saj naj bi bil to razlog, da ga prakticno nihce se ni kupil. Govori se, da bi bilo potrebno mocno spremeniti letaliske terminale in utrditi pristajalno-vzletne steze na letaliscih, da bi vse skupaj sploh lahko normalno obratovalo, preprosto naj bi bil prevelik za danasnje dni. Ampak samo malo, kaj niso iste skrbi obletavale prejsnega nebeskega kita Boeinga 747, letala, ki je trenutno najuspesnejse komercialno letalo vseh casov? Dajte ubogemu mladicu malo casa ljudje, se bo ze prijel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      